import React, { useEffect, useState } from "react";
import { Layers, Briefcase } from "lucide-react";

import { v2Api } from "@/lib/v2Api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function TemplatesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    v2Api.templates()
      .then((d) => setItems(d || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-8 max-w-5xl mx-auto space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900 flex items-center gap-2">
          <Layers className="w-5 h-5 text-blue-600" /> Project Templates
        </h1>
        <p className="text-sm text-slate-500">
          Pre-canned project blueprints. New projects can be cloned from a
          template (or another project) on the Projects page.
        </p>
      </div>

      {loading && <p className="text-sm text-slate-500">Loading…</p>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((t) => (
          <Card key={t.id}>
            <CardHeader className="pb-2">
              <div className="flex items-center justify-between gap-2">
                <CardTitle className="text-base flex items-center gap-2">
                  <Briefcase className="w-4 h-4 text-slate-400" /> {t.name}
                </CardTitle>
                {t.is_default && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-blue-100 text-blue-700">default</span>
                )}
              </div>
              <p className="text-[10px] uppercase tracking-wider text-slate-400 font-medium">
                {t.code} · {t.portal || "—"}
              </p>
            </CardHeader>
            <CardContent className="text-sm space-y-1">
              {t.description && <p className="text-slate-600">{t.description}</p>}
              {t.payload_summary && Object.keys(t.payload_summary).length > 0 && (
                <pre className="text-[10px] bg-slate-50 p-2 rounded-md overflow-x-auto text-slate-600">
                  {JSON.stringify(t.payload_summary, null, 2)}
                </pre>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
